<template>
  <span :class="tag_classes">
    <FontAwesomeIcon
      v-if="icon"
      :icon="icon"
    />
    <span
      v-if="$slots.default"
      :class="{ truncate: truncate }"
    >
      <slot />
    </span>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { STATUS, STATUS_COLORS } from '@/app/data/status_constants';

const props = defineProps({
  color: {
    type: String,
    default: STATUS.DEFAULT,
    validator: (value) => Object.values(STATUS).includes(value),
  },
  icon: { type: [Array, String], default: null },
  size: {
    type: String,
    default: 'small',
    validator: (value) => ['small', 'medium'].includes(value),
  },
  truncate: { type: Boolean, default: false },
});

const tag_classes = computed(() => {
  const theme = STATUS_COLORS[props.color];
  const size_classes = props.size === 'medium' ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-xs';

  return ['inline-flex items-center gap-1 rounded-full font-medium', theme.TAG_BG, theme.TAG_TEXT, size_classes];
});
</script>
